module.exports = __webpack_public_path__ + "static/media/pancakeswap.156a7e61.gif";